<template>
  <div class="trial-block">
    <template v-if="!isExpired">
      <div class="trial-header">
        <div class="clock-icon">
          <eg-icon
            icon="clock"
            size="medium"
            color="var(--color-icon-primary-primary)"
          />
        </div>
        <span class="trial-text caption-s"
          >{{ daysLeft }} days left in your Free Trial</span
        >
      </div>

      <div class="trial-progress-bar">
        <div
          class="trial-progress-fill"
          :style="{ width: progressPercent + '%' }"
        ></div>
      </div>
    </template>

    <template v-else>
      <div class="trial-expired-content">
        <h3 class="trial-expired-title caption-s">
          Your trial has ended, upgrade to keep all your favorite features!
        </h3>

        <ul
          v-if="Array.isArray(trialEndFeaturesList)"
          class="trial-features-list"
        >
          <li
            v-for="(value, index) in trialEndFeaturesList"
            :key="index"
            class="trial-feature-item caption-s"
          >
            <eg-icon icon="check" size="small" color="#9333ea" />
            <span>{{ value }}</span>
          </li>
        </ul>
        <p v-else class="trial-features-string caption-s">
          {{ trialEndFeaturesList }}
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "PlanBannerTrial",
  props: {
    daysLeft: {
      type: Number,
      default: 0,
    },
    totalDays: {
      type: Number,
      default: 7,
    },
    isExpired: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    progressPercent() {
      const daysUsed = this.totalDays - (this.totalDays - this.daysLeft);
      return (daysUsed / this.totalDays) * 100;
    },
    trialEndFeaturesList() {
      return this.$store.getters.trialEndFeaturesList;
    },
  },
});
</script>

<style scoped lang="scss">
.trial-block {
  margin-bottom: 12px;

  .trial-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;

    .clock-icon {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: var(--color-surface-primary-light-1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
  }

  .trial-progress-bar {
    width: 100%;
    height: 8px;
    background-color: #e5e7eb;
    border-radius: 4px;
    overflow: hidden;

    .trial-progress-fill {
      height: 100%;
      background: linear-gradient(90deg, #9333ea 0%, #e11d48 50%, #f97316 100%);
      border-radius: 4px;
      transition: width 0.3s ease;
    }
  }

  .trial-expired-content {
    .trial-expired-title {
      margin: 0 0 16px 0;
    }

    .trial-features-list {
      display: flex;
      gap: 8px;
      flex-direction: column;
      list-style: none;
      margin: 0;
      padding: 8px;
      border-radius: var(--radius-rd-300, 8px);
      background: var(--color-surface-neutral-container-1);

      .trial-feature-item {
        display: flex;
        align-items: center;
        gap: 12px;
        color: var(--color-text-neutral-secondary);
      }
    }
  }
}
</style>
